// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '5c7278f2f1b4f83c18363d07799770c7597b262c';
export const BUILD_NUMBER = '224';
export const BUILD_TIMESTAMP = '2026-09-07T03:22:50.806Z';
